import { DefineComponent, defineAsyncComponent } from 'vue';

// 使用懒加载方式导入组件，只有在实际使用时才会加载
const modules = import.meta.glob('./*/index.(tsx|vue)');

const components: Record<string, DefineComponent> = {};

for (const path in modules) {
  const componentName = path.split('/')[1];
  // 使用 defineAsyncComponent 实现懒加载，提升首屏加载性能
  components[componentName + 'Ctl'] = defineAsyncComponent({
    loader: modules[path] as any,
    // 加载时显示的组件（可选）
    // loadingComponent: LoadingComponent,
    // 加载失败时显示的组件（可选）
    // errorComponent: ErrorComponent,
    // 延迟显示 loading 组件的时间，默认 200ms
    delay: 200,
    // 超时时间
    timeout: 30000
  });
}

export default components;
